import React from 'react';

import PropTypes from 'prop-types';

import styles from './HeaderFixedButton.module.css';

const HeaderFixedButton = (props) => {
    return (
        <a
            className={`${styles.headerButton} ${props.variant === 'primary' ? styles.headerButtonPrimary : styles.headerButtonSecondary} ${props.fixedButton ? styles.headerButtonFixed : ''}`}
            href={props.href}
            id={props.id}
            onClick={props.onClick}
            tabIndex={'0'}
            target={props.targetBlank ? '_blank' : null}
        >
            {props.caption}
        </a>
    );
};

HeaderFixedButton.propTypes = {
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    variant: PropTypes.oneOf(['primary', 'secondary']),
    href: PropTypes.string,
    id: PropTypes.string,
    onClick: PropTypes.func,
    targetBlank: PropTypes.bool,
    fixedButton: PropTypes.bool,
};
export default HeaderFixedButton;
